const ventas = {
  readChangePlan: 'venta/{uuid_venta}/change-plan',
  readVenta: 'academia/venta/{{uuid_venta}}',
  readCompra: 'academia/{{uuid_academia}}/compra/{{uuid_venta}}',
  readVentaPagos: 'academia/venta/{{uuid_venta}}/pagos',
  readVentas: 'academia/ventas/{{uuid_academia}}',
  readComprasAlumno: 'alumno/{{uuid_academia}}/compras',
  readVentasCobros: 'academia/ventas/cobros/{{uuid_academia}}',
  readVentasExportar: 'academia/ventas/{{uuid_academia}}/exportar',
  readVentaProductoGestiones: 'venta/{{uuid_producto}}/gestiones',
  readVentasPagosAcademiaExportar: 'academia/{{uuid_academia}}/pagos/exportar',
  readVentasPagosAlumno: 'alumno/{{uuid_academia}}/pagos',
  readSubscriptionNotificada: 'academia/ventas/suscripciones/{uuid_venta}',
  readVentasPagosAcademia: 'academia/{{uuid_academia}}/pagos',
  replaceSubscription: 'academia/{{uuid_academia}}/compra/{{uuid_venta}}/replace-subscription',
  updateVentasAnularPago: 'academia/venta/{{uuid_venta}}/pago/{{uuid_pago}}/anular',
  updateVentasConfirmarPago: 'academia/venta/{{uuid_venta}}/pago/{{uuid_pago}}/confirmar',
  updateVentasReembolsarPago: 'academia/venta/{{uuid_venta}}/pago/{{uuid_pago}}/reembolsar' /* no está en postman */
}

export default ventas
